import { z } from 'zod';
import { suretyAccountUnderwritingStatusSchema, contractSuretyAccountUnderwritingModelSizeSchema } from '../../../../enums.mjs';
import { isoDateTimeSchema, suretyAccountUnderwritingId } from '../../../../types/opaque.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.object({
            id: suretyAccountUnderwritingId,
            createdAt: isoDateTimeSchema,
            status: suretyAccountUnderwritingStatusSchema,
            reviewReasons: z.array(z.object({ description: z.string() })),
            supplementalRequirements: z.array(z.string()).default([]),
            availableModelSizes: z.array(contractSuretyAccountUnderwritingModelSizeSchema),
            stale: z.boolean(),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var List;
(function (List) {
    (function (Response) {
        Response.schema = z.array(Get.Response.schema);
    })(List.Response || (List.Response = {}));
})(List || (List = {}));

export { Get, List };
